import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { NotFoundLayout } from './NotFoundLayout';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t('page.notFound.meta.title')} />
      <NotFoundLayout />
    </>
  );
}
